import controller from './pre-info-form-dialog.controller';

export default {
  controller,
  template: require('./pre-info-form-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/pre-info-form-dialog/pre-info-form-dialog.component.ts